var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_widget)?_c('LiveChatWidget',{attrs:{"license":_vm.license,"customerName":_vm.customerName,"customerEmail":_vm.customerEmail,"group":"0","visibility":_vm.visibility,"chatBetweenGroups":false},on:{"ready":_vm.handleReadyEvent,"visibility-changed":_vm.handleVisibilityChanged}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }